import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
const minADA = 5000000n;
export const useGetChosenUtxos = () => {
    const [notEnoughADA, setNotEnoughADA] = useState(true);
    const mutation = useMutation(async (data) => {
        const totalAda = data.reduce((a, u) => a + BigInt(u.amount.coin), 0n);
        if (totalAda < minADA) {
            setNotEnoughADA(true);
        }
        else {
            setNotEnoughADA(false);
        }
        return data;
    });
    return { mutation, notEnoughADA };
};
//# sourceMappingURL=useGetChosenUtxos.js.map